export default __webpack_public_path__ + "static/media/LR.0490fde7.svg";